import { Badge } from "antd";

export const CardBadge = ({
  text,
  color,
}: {
  text: string;
  color?: string;
}) => {
  return (
    <Badge.Ribbon
      text={text}
      color={color}
      placement="start"
      style={{
        position: "absolute",
        top: -30, //40px card body top padding, 10px badge top margin
        left: -33, //24px card body padding, 8px badge padding, 1px card border
        fontSize: 12,
      }}
    />
  );
};
